import controller from './family-plan-user-registration-dialog.controller';

export default {
  controller,
  template: require('./family-plan-user-registration-dialog.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-user-registration-dialog/family-plan-user-registration-dialog.component.ts